<template>
    <div
        :class="opendata_class"
        style="display: inline-block;"
        :id="openid"
    >
        <ww-open-data
            :type="type"
            :openid="openid"
        />
    </div>

</template>
<script>
export default {
    props: ["type", "openid", "opendata_class","userName","departmentName"],
    mounted() {
        var _this = this;
        var _ele = this.$el
        WWOpenData.bind(_ele);
        console.log('_________',this.openid)

        // setTimeout(()=>{
        //     _ele && (_ele.innerHTML = _this.openid )
        // },1000)

        if (WWOpenData.on) {
            WWOpenData.on("error", () => {
                var innerText = ''
                if(_this.type == 'departmentName' && _this.departmentName){
                    innerText = _this.departmentName
                }else if(_this.type == 'userName' && _this.userName){
                    innerText = _this.userName
                }else{
                    innerText = _this.openid
                }
                _ele && (_ele.innerHTML = innerText)
            });
        }
    },
};
</script>
<style lang="scss" scoped>
.depa_nowrap {
    width: 2.9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>